module.exports = __webpack_public_path__ + "img/pv-04.b2f3443d.svg";